module.exports = require('./helpers/bundle-url').getBundleURL('dQMqr') + "logo-dark.eefe0b7f.svg";